<template>
	<div class="spinner-wrap" v-if="loading">
  	<div class="spinner"></div>
	</div>
</template>

<script>
import $ from 'jquery'

export default {
	name: 'Spinner',
	props: {
		loading: {
			type: Boolean,
			required: true
		}
	},

	watch: {
		loading: function () {
			if (this.loading) {
				const scrollY = window.scrollY || window.pageYOffset
				const screenHeight = window.innerHeight
				const centerY = parseInt(scrollY + screenHeight / 2)
				// const animationStyle = document.styleSheets[0].cssRules[0].style
				// animationStyle.setProperty('--top-mid', centerY + 'px')
				const style = document.documentElement.style
				style.setProperty('--top-mid', centerY + 'px')
			}
		}
	}
}
</script>

<style scoped>
.spinner-wrap {
	position: fixed;
	left: 0;
	top: 0;
	z-index: 10000;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	/* background: rgba(0, 0, 0, .5); */
	/*backdrop-filter: blur(2px);*/
}

.spinner {
   width: 11.2px;
   height: 11.2px;
   border-radius: 11.2px;
   box-shadow: 28px 0px 0 0 rgba(90,87,170,0.2), 22.7px 16.5px 0 0 rgba(90,87,170,0.4), 8.68px 26.6px 0 0 rgba(90,87,170,0.6), -8.68px 26.6px 0 0 rgba(90,87,170,0.8), -22.7px 16.5px 0 0 #5a57aa;
   animation: spinner-b87k6z 1s infinite linear;
}

@keyframes spinner-b87k6z {
   to {
      transform: rotate(360deg);
   }
}
</style>
